function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCurrentUser } from "@sprout/client-graphql";
import { MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { Button } from "sprout-ui-dom";
import AppMoreMenu from "../../../AppMoreMenu";
import Avatar from "../../../Avatar";
const AppBarAppDesktopAppMoreMenu = ()=>{
    const menuState = useMenuState();
    const currentUser = useCurrentUser();
    if (!currentUser) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "circle",
                    color: "black.87",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        user: currentUser,
                        size: 36
                    })
                })
            })),
            /*#__PURE__*/ _jsx(AppMoreMenu, _objectSpread({}, menuState))
        ]
    });
};
export default AppBarAppDesktopAppMoreMenu;
